import { Container, CartaoNavegacao, Conteudo, Linha, NavegacaoSecao, SecaoConteudo } from "./styles";
import { useHistory, useParams } from "react-router-dom";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import toast from "react-hot-toast";
import { toastDefsError } from "../../../config/toastConfig";
import AbaErro from "../Common/AbaErro";
import AbaAcessoNegado from "../Common/AbaAcessoNegado";

import CancelamentoDemanda from "./CancelamentoDemanda";
import RecusaEntregaDemanda from "./RecusaEntregaDemanda";
import ObservacoesConclusao from "./ObservacoesConclusao";
import InterrupcoesProfissionais from "./InterrupcoesProfissionais";
import ObservacoesFinalizacao from "./ObservacoesFinalizacao";
import OrientacoesCompletas from "./OrientacoesCompletas";
import OrientacoesPrevias from "./OrientacoesPrevias";
import RecusasProfissionais from "./RecusasProfissionais";
import { verificarDemandaCancelada, verificarDemandaConcluida, verificarDemandaRecusada, verificarStatusBloqueadoOrientacaoCompleta, verificarDemandaInterrompida, verificarDemandaFinalizada } from "./utils";
import { useAuth } from "../../../contexts/UserContext";

const secoes = [
    { id: "cancelamento-demanda", rotulo: "Cancelamento da Demanda" },
    { id: "recusa-entrega-demanda", rotulo: "Recusa da Entrega" },
    { id: "observacoes-finalizacao", rotulo: "Finalização da demanda" },
    { id: "observacoes-conclusao", rotulo: "Conclusão do profissional" },
    { id: "observacoes-interrupcao", rotulo: "Interrupção do profissional" },
    { id: "orientacoes-previas", rotulo: "Orientações Prévias" },
    { id: "orientacoes-completas", rotulo: "Orientações Completas" },
    { id: "recusas-profissionais", rotulo: "Recusas de Profissionais" },
] as const;

export default function AbaOrientacoes({ abaAtiva, demanda, onRecarregarDemanda, loading = false, error, acessoNegado, onRetry, onNavigateToFile }: any) {
    const { user } = useAuth();
    const history = useHistory();
    const params = useParams<any>();
    const id: number = params.id;
    const [carregandoOrientacaoPrevia, setCarregandoOrientacaoPrevia] = useState(false);

    if (abaAtiva !== "orientacoes") {
        return null;
    }

    if (acessoNegado) {
        return <AbaAcessoNegado />;
    }

    if (error && onRetry) {
        return <AbaErro mensagem="Não foi possível carregar orientações." onRetry={onRetry} />;
    }

    const demandaCancelada = verificarDemandaCancelada(demanda);
    const demandaConcluida = verificarDemandaConcluida(demanda);
    const demandaInterrompida = verificarDemandaInterrompida(demanda);
    const demandaRecusada = verificarDemandaRecusada(demanda);
    const demandaFinalizada = verificarDemandaFinalizada(demanda);
    const temInterrupcoes = (demanda?.interrupcoes_profissionais || []).length > 0;

    const handleAdicionarOrientacaoCompleta = () => {
        const { bloqueado, statusAtual } = verificarStatusBloqueadoOrientacaoCompleta(demanda);
        
        if (bloqueado) {
            toast.error(`Não é possível registrar uma Orientação Completa para demandas com status ${statusAtual}.`, toastDefsError);
            return;
        }

        if (!demanda?.id_usuario) {
            toast.error('Não é possível registrar uma Orientação Completa sem um Correspondente vinculado à demanda.', toastDefsError);
            return;
        }

        history.push(`/demandas/${id}/orientacoes/orientacoes-completas`);
    };

    const handleEditarOrientacaoCompleta = (orientacao: any) => {
        history.push({
            pathname: `/demandas/${id}/orientacoes/orientacoes-completas`,
            state: { orientacao }
        });
    };

    const podeVerCancelamento = user?.profile !== 'comum' && user?.profile !== 'Solicitante';
    
    const podeVerConclusao = user?.profile === 'admin' || 
                             user?.profile === 'operador' || 
                             (user?.profile === 'comum' && Number(user?.id) === demanda?.id_usuario);
    const podeVerRecusasProfissionais = user?.profile === 'admin' || user?.profile === 'operador';
    const podeVerInterrupcao = user?.profile === 'admin' || user?.profile === 'operador';
    
    // ERRO26: Só mostrar seção de recusas se houver recusas
    const temRecusas = (demanda?.recusas_profissionais || []).length > 0;

    const secoesVisiveis = secoes.filter((secao) => {
        if (secao.id === "cancelamento-demanda") {
            return demandaCancelada && podeVerCancelamento;
        }
        if (secao.id === "recusa-entrega-demanda") {
            return demandaRecusada;
        }
        if (secao.id === "observacoes-conclusao") {
            return demandaConcluida && podeVerConclusao;
        }
        if (secao.id === "observacoes-interrupcao") {
            return temInterrupcoes && podeVerInterrupcao;
        }
        if (secao.id === "observacoes-finalizacao") {
            return demandaFinalizada && (user?.profile === 'admin' || user?.profile === 'operador');
        }
        if (secao.id === "recusas-profissionais") {
            // ERRO26: Só mostrar atalho se houver recusas E usuário pode ver
            return podeVerRecusasProfissionais && temRecusas;
        }
        return true;
    });

    const rolarPara = (id: string) => {
        const alvo = document.getElementById(id);
        if (alvo) {
            alvo.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    const handleSalvarOrientacaoPrevia = async () => {
        setCarregandoOrientacaoPrevia(true);
        await onRecarregarDemanda();
        setCarregandoOrientacaoPrevia(false);
    };

    return (
        <Container>
            <CartaoNavegacao>
                <Conteudo>
                    <Linha $centralizado>
                        {(loading && !carregandoOrientacaoPrevia) ? (
                            <>
                                <Skeleton width={180} height={16} style={{ margin: '0 10px' }} />
                                <Skeleton width={180} height={16} style={{ margin: '0 10px' }} />
                                <Skeleton width={200} height={16} style={{ margin: '0 10px' }} />
                            </>
                        ) : (
                            secoesVisiveis.map((secao) => (
                                <NavegacaoSecao key={secao.id} onClick={() => rolarPara(secao.id)}>
                                    {secao.rotulo}
                                </NavegacaoSecao>
                            ))
                        )}
                    </Linha>
                </Conteudo>
            </CartaoNavegacao>
            {demandaCancelada && podeVerCancelamento && (
                <SecaoConteudo id="cancelamento-demanda">
                    <CancelamentoDemanda demanda={demanda} />
                </SecaoConteudo>
            )}
            {demandaRecusada && (
                <SecaoConteudo id="recusa-entrega-demanda">
                    <RecusaEntregaDemanda demanda={demanda} />
                </SecaoConteudo>
            )}
            {demandaFinalizada && (user?.profile === 'admin' || user?.profile === 'operador') && (
                <SecaoConteudo id="observacoes-finalizacao">
                    <ObservacoesFinalizacao demanda={demanda} loading={loading && !carregandoOrientacaoPrevia} />
                </SecaoConteudo>
            )}
            {demandaConcluida && podeVerConclusao && (
                <SecaoConteudo id="observacoes-conclusao">
                    <ObservacoesConclusao demanda={demanda} loading={loading && !carregandoOrientacaoPrevia} onNavigateToFile={onNavigateToFile} />
                </SecaoConteudo>
            )}
            {temInterrupcoes && podeVerInterrupcao && (
                <SecaoConteudo id="observacoes-interrupcao">
                    <InterrupcoesProfissionais demanda={demanda} loading={loading && !carregandoOrientacaoPrevia} onNavigateToFile={onNavigateToFile} />
                </SecaoConteudo>
            )}
            <SecaoConteudo id="orientacoes-previas">
                <OrientacoesPrevias 
                    demanda={demanda} 
                    onSalvar={handleSalvarOrientacaoPrevia} 
                    loading={loading || carregandoOrientacaoPrevia} 
                />
            </SecaoConteudo>
            <SecaoConteudo id="orientacoes-completas">
                <OrientacoesCompletas 
                    demanda={demanda} 
                    onAdicionar={handleAdicionarOrientacaoCompleta}
                    onEditar={handleEditarOrientacaoCompleta}
                    loading={loading && !carregandoOrientacaoPrevia}
                    onNavigateToFile={onNavigateToFile}
                    onRecarregar={onRecarregarDemanda}
                />
            </SecaoConteudo>
            {podeVerRecusasProfissionais && temRecusas && (
                <SecaoConteudo id="recusas-profissionais">
                    <RecusasProfissionais demanda={demanda} loading={loading && !carregandoOrientacaoPrevia} />
                </SecaoConteudo>
            )}
        </Container>
    );
}
